import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seller_filter = _resolveComponent("seller-filter");
  const _component_marketplace_filter = _resolveComponent("marketplace-filter");
  const _component_empty_segments = _resolveComponent("empty-segments");
  const _component_segment_filter = _resolveComponent("segment-filter");
  const _component_product_filter = _resolveComponent("product-filter");
  const _component_brand_filter = _resolveComponent("brand-filter");
  const _component_filters_frame = _resolveComponent("filters-frame");
  return _openBlock(), _createBlock(_component_filters_frame, {
    class: "dashboard-v2-filters"
  }, {
    default: _withCtx(() => [_createVNode(_component_seller_filter, {
      sellers: _ctx.sellers_filter,
      onApply: $options.applySellers
    }, null, 8, ["sellers", "onApply"]), _createVNode(_component_marketplace_filter, {
      marketplaces: _ctx.marketplaces_filter,
      onApply: $options.applyMarketplaces
    }, null, 8, ["marketplaces", "onApply"]), _createVNode(_component_segment_filter, {
      segments: _ctx.segments,
      sellers: _ctx.sellers_filter,
      onApply: $options.applySegments
    }, {
      empty: _withCtx(() => [_createVNode(_component_empty_segments)]),
      _: 1
    }, 8, ["segments", "sellers", "onApply"]), _createVNode(_component_product_filter, {
      products: _ctx.products,
      sellers: _ctx.sellers_filter,
      marketplaces: _ctx.marketplaces_filter,
      onApply: $options.applyProducts,
      onCleared: $options.handleProductsCleared
    }, null, 8, ["products", "sellers", "marketplaces", "onApply", "onCleared"]), $options.showBrandsFilter ? (_openBlock(), _createBlock(_component_brand_filter, {
      key: 0,
      brands: _ctx.brands,
      onApply: $options.applyBrands
    }, null, 8, ["brands", "onApply"])) : _createCommentVNode("", true)]),
    _: 1
  });
}